import React, { useCallback, useEffect, useState } from 'react';
import { Card, Table, Space, Button, Input, Tag, message } from 'antd';
import { ReloadOutlined, EditOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import apiService from '@/services/apiService';

type MissingRow = {
  skuId: string
  skuNameZh?: string | null
  skuNameEn?: string | null
  brand?: string | null
  occurrences?: number
  firstSeen?: string
  lastSeen?: string
  productId?: string
  productCreatedAt?: string
}

const HKTVmallMissingSkus: React.FC = () => {
  const navigate = useNavigate()
  const [rows, setRows] = useState<MissingRow[]>([])
  const [query, setQuery] = useState('')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)
      const resp: any = await apiService.getHKTVMissingSkus({ page, limit: pageSize, q: query || undefined })
      if (!resp?.success) throw new Error(resp?.message || 'load failed')
      const list: MissingRow[] = Array.isArray(resp?.data) ? resp.data : (resp?.rows || [])
      setRows(list || [])
      const p = resp?.pagination || {}
      setTotal(Number(p.total || list.length || 0))
    } catch (e) {
      console.error(e)
      message.error('載入自動建立產品列表失敗')
      setRows([])
      setTotal(0)
    } finally {
      setLoading(false)
    }
  }, [page, pageSize, query])

  useEffect(() => { fetchData() }, [fetchData])

  const handleGoToProduct = (row: MissingRow) => {
    navigate(`/inventory/products?sku=${encodeURIComponent(row.skuId)}`)
  }

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Card title="HKTVmall 自動建立產品">
        <Space style={{ marginBottom: 12 }} wrap>
          <Input.Search placeholder="搜尋 SKU/名稱/品牌" allowClear style={{ width: 320 }}
            onSearch={(v)=>{ setPage(1); setQuery(v); }} onChange={(e)=> setQuery(e.target.value)} />
          <Button icon={<ReloadOutlined />} loading={loading} onClick={fetchData}>刷新</Button>
        </Space>

        <Table
          rowKey={(r)=> r.skuId}
          dataSource={rows}
          loading={loading}
          pagination={{ current: page, pageSize, total, onChange:(p, ps)=>{ setPage(p); setPageSize(ps); } }}
          columns={[
            { title:'SKU', dataIndex:'skuId', width: 180 },
            { title:'名稱(中)', dataIndex:'skuNameZh', width: 200 },
            { title:'名稱(英)', dataIndex:'skuNameEn', width: 200 },
            { title:'品牌', dataIndex:'brand', width: 120, render:(v)=> v ? <Tag>{v}</Tag> : '-' },
            { title:'出現次數', dataIndex:'occurrences', width: 100 },
            { title:'產品建立時間', dataIndex:'productCreatedAt', width: 160, render:(v)=> v ? new Date(v).toLocaleString('zh-TW') : '-' },
            { title:'訂單最近出現', dataIndex:'lastSeen', width: 160, render:(v)=> v ? new Date(v).toLocaleString('zh-TW') : '-' },
            {
              title:'操作',
              key:'actions',
              width: 120,
              fixed: 'right',
              render: (_: any, record: MissingRow) => (
                <Button
                  type="link"
                  size="small"
                  icon={<EditOutlined />}
                  onClick={() => handleGoToProduct(record)}
                >
                  前往編輯
                </Button>
              ),
            },
          ]}
        />
      </Card>
    </Space>
  )
}

export default HKTVmallMissingSkus


